export default __webpack_public_path__ + "static/media/howItWorks.93d2b1fb.svg";